export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";